export function formatDate(iso) {
  if (!iso) return "-";
  return new Date(iso).toLocaleDateString("en-US", { month: "short", day: "numeric", year: "numeric" });
}

export function formatDateTime(iso) {
  if (!iso) return "-";
  return new Date(iso).toLocaleString("en-US", { month: "short", day: "numeric", hour: "2-digit", minute: "2-digit" });
}

export function formatAction(a) {
  if (a.action === "created") return "created this ticket";
  if (a.action === "status_changed") return `changed status from ${a.old_value} to ${a.new_value}`;
  if (a.action === "assigned") return `assigned to ${a.new_value || "unassigned"}`;
  if (a.action === "comment_added") return `added a ${a.new_value} comment`;
  if (a.action === "updated") return `updated ${a.field} from "${a.old_value}" to "${a.new_value}"`;
  if (a.action === "linked_ticket") return `linked ticket ${a.details?.target_ticket_number || ""}`;
  if (a.action === "logged_time") return `logged ${a.details?.minutes || 0} minutes`;
  if (a.action === "attachment_uploaded") return `uploaded ${a.details?.filename || "a file"}`;
  if (a.action === "attachment_deleted") return `deleted ${a.details?.filename || "a file"}`;
  return a.action?.replace("_", " ") || "performed an action";
}

export function formatAuditDetail(log) {
  const d = log.details || {};
  switch (log.action) {
    case "status_changed": return `${d.from || "?"} → ${d.to || "?"}`;
    case "assigned": return d.assigned_to_name ? `to ${d.assigned_to_name}` : "";
    case "logged_time": return d.minutes ? `${d.minutes} min` : "";
    case "linked_ticket": return d.target_ticket_number ? `→ ${d.target_ticket_number}` : "";
    default: return d.field ? `${d.field}: ${d.old_value || "—"} → ${d.new_value || "—"}` : "";
  }
}
